import { Context } from '@vue-storefront/core';
import Cache from '../cache/cache';


export default async function configAll(context: Context, params: any): Promise<Object> {
  // 获取缓存
  const cacheKey = 'configAll_' + params.lang;
  if (!params || !params.debug) {
    const cache = Cache.getCache(context, cacheKey);
    if (cache) {
      return cache;
    }
  }

  const url = new URL('/mall/config/all', context.config.api.url);
  const { data: res } = await context.client.post(url.href, params);
  const result = res?.data?.list || {};

  Cache.setCache(context, cacheKey, result);
  return result;
}
